import * as React from "react"
import { 
  TextInput, 
  ImageInput, 
  ImageField, 
  ArrayInput, 
  SimpleFormIterator
} from "react-admin"
import { useEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Grid } from "@mui/material"
import isEqual from "lodash/isEqual"; 

const ColorOptionsTab = () => {
  const { setValue, getValues } = useFormContext();
  const colors = useWatch({ name: 'colors' });

  const preColorsRef = useRef([]);

  useEffect(() => {
    const currentColors = colors || [];

    const updatedColor = currentColors.map(c => c?.name || "");
    
    if (isEqual(preColorsRef.current, updatedColor)) return;

    preColorsRef.current = updatedColor;

    const editableAreas = getValues('editableAreas')
    for ( let i in editableAreas ) {
      editableAreas[i].images = updatedColor.map((colorName, ii) => {
        const index = editableAreas[0].images.findIndex(image => image.name === colorName);
        if (index >= 0) {
          return {
            ...editableAreas[i].images[index],
            name: colorName
          }
        } else {
          console.log(updatedColor);
          if (updatedColor.length === 1) {
            return {
              ...editableAreas[i].images[ii],
              name: colorName
            }
          } else {
            return {
              image: [],
              name: colorName
            }
          }
        }
      })
    }
    setValue('editableAreas', editableAreas)
  }, [colors, getValues, setValue, preColorsRef]);

  return (
    <Grid container width={{ xs: "100%", xl: 800 }} spacing={2}>
      <Grid item xs={12}>
        <ArrayInput source="colors" label="顏色選項">
          <SimpleFormIterator getItemLabel={index => `#${index + 1}`}>
            <Grid container>
              <Grid item xs={12} sm={12}>
                <TextInput source="name" label="選項名稱" />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextInput source="code" label="HEX色碼" sx={{ display: "none" }} />
              </Grid>
            </Grid>
            <ImageInput 
              source="navImage" 
              label="顏色選項圖片" 
              accept={{ 'image/*': ['.png', '.jpg'] }} 
              sx={{
                "& .previews": {
                  backgroundColor: "#f0f0f0",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                },
              }}
            >
              <ImageField source="src" title="title" />
            </ImageInput>
            <ImageInput 
              source="image" 
              label="對應的商品圖" 
              accept={{ 'image/*': ['.png', '.jpg'] }}
              sx={{
                "& .previews": {
                  backgroundColor: "#f0f0f0",
                  padding: "10px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                },
                display: "none",
                marginTop: "1rem",
              }}
            >
              <ImageField source="src" title="title" />
            </ImageInput>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  )
}

export default ColorOptionsTab;